// import { Avatar } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BookingApi from "../../../API/Apis/BookingApi";
import { t } from "i18next";
import { ArrowDropDownOutlined } from "@mui/icons-material";
import createTheme from "@mui/material/styles/createTheme";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import type { Theme } from "@mui/material/styles";
// import { createTheme, Theme, ThemeProvider } from "@mui/material/styles";
import theme, {
  formatThemeForReservedArea,
} from "../../../config/MuiColorThemes";
import { Logout } from "../../UI/AppModal";
import Typography from "@mui/material/Typography";

function BookingDetalisListSideNavigation() {
  const [dynamicTheme, setDynamicTheme] = useState<Theme | null>(null);
  useEffect(() => {
    async function fetchTheme() {
      const dynamicPalette = await formatThemeForReservedArea();
      const theme = createTheme(dynamicPalette);
      setDynamicTheme(theme);
    }
    fetchTheme();
  }, []);
  const navigateTo = useNavigate();
  const [activeTab, setActiveTab] = useState("");
  const handleProfileTabClick = (tab) => {
    setActiveTab(tab === activeTab ? "" : tab);
  };
  const [userData, setUserData] = useState([]);
  const [isActive, setIsActive] = useState("");
  const className =
    "flex items-center gap-4 hover:bg-[#000000] cursor-pointer rounded-2xl";

  const handleTabClick = (tab) => {
    setIsActive(tab);
  };
  const isLogged = localStorage.getItem("isUserLoggedin");

  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(true);

  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }

  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);

  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  const scrollToTop = () => {
    window.scrollTo(0, 0);
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      targetOrigin
    );
  };
  const handleClickOpen = () => {
    scrollToTop();
    window.scrollTo(0, 0);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const isSmallScreen = window.innerWidth <= 768;
  const [userId] = useState(localStorage.getItem("userID"));
  useEffect(() => {
    const id: any = localStorage.getItem("userID");
    if (userId != null && userId != "null" && userId != "") {
      BookingApi.getUserProfileByUserId(id).then((e) => {
        setUserData(e.data.onlineUser[0]);
        setLoader(false);
      });
    }
  }, []);

  function OncustomerDetalis() {
    scrollToTop();
    navigateTo("/customerDetailsList");
  }

  const handleReservationListEvent = () => {
    scrollToTop();
    navigateTo("/myReservedBookings", {
      state: { showConfimedReservations: true },
    });
  };

  function handleInvoiceListEvent() {
    scrollToTop();
    navigateTo("/myInvoices");
  }

  function handleCreateBooking() {
    scrollToTop();
    navigateTo("/");
  }

  function handlePersonalInfo() {
    scrollToTop();
    navigateTo("/profile");
  }

  function handleChangePassword() {
    scrollToTop();
    navigateTo("/changePassword");
  }

  function handleLogout() {
    BookingApi.logout();
    localStorage.setItem("isUserLoggedin", "false");
    navigateTo("/signin");
  }
  return (
    <ThemeProvider theme={dynamicTheme || theme}>
      <div
        className="text-[#000] p-12 shadow-[5px_0px_16px_3px_#00000024]"
        style={{
          height: "128vh",
          fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
          backgroundColor: "#000000",
          color: "#FDFDFD",
        }}
      >
        <div className="pt-2">
          <ul className="flex items-center gap-4 mt-4">
            <li>
              <Avatar
                alt={
                  loader ? (
                    <>
                      {" "}
                      <Typography
                        className="!text-center !text-3xl !flex !justify-center"
                        style={{
                          fontFamily: " MBCorpoAScreen1Cond-Regular-Web",
                        }}
                      >
                        Loading...
                      </Typography>
                    </>
                  ) : (
                    `${userData.firstName}`
                  )
                }
                src="/assets/images/user.png"
              />
            </li>
            <li
              className={`font-poppins_regular text-[20px] ${
                isActive == "tab0" ? "bg-gray-700" : ""
              }`}
            >
              {loader ? (
                <>
                  {" "}
                  <Typography
                    className="!text-center !text-3xl !flex !justify-center"
                    style={{ fontFamily: " MBCorpoAScreen1Cond-Regular-Web" }}
                  >
                    Loading...
                  </Typography>
                </>
              ) : (
                userData.firstName + " " + userData.lastName
              )}
            </li>
          </ul>
        </div>
        <div className="mt-6">
          <ul className="flex flex-col gap-6 text-base ">
            <li
              style={{ padding: "4px" }}
              onClick={() => {
                handleCreateBooking();
                handleTabClick("tab1");
              }}
              className={className}
            >
              <img
                className="h-6"
                src="/assets/images/bookingCreateIcon.png"
                alt="Create Booking"
              />
              {t("Create Booking")}
            </li>
            <li
              style={{ padding: "4px" }}
              onClick={() => {
                OncustomerDetalis();
                handleTabClick("tab2");
              }}
              className={className}
            >
              <img
                className="h-6"
                src="/assets/images/customerDetailsIcon.png"
                alt="Customer Details"
                style={{ height: "16px", width: "22px" }}
              />
              {t("Customer Details")}
            </li>
            <li
              style={{ padding: "4px" }}
              onClick={() => {
                handleReservationListEvent();
                handleTabClick("tab3");
              }}
              className={className}
            >
              <img
                className="h-6"
                src="/assets/images/reservationIcon.png"
                alt="Reservation"
              />
              {t("Reservation")}
            </li>
            <li
              style={{ padding: "4px" }}
              onClick={() => {
                handleInvoiceListEvent();
                handleTabClick("tab4");
              }}
              className={className}
            >
              <img
                className="h-6"
                src="/assets/images/invoiceBookIcon.png"
                alt="List of invoice"
              />
              {t("Invoice")}
            </li>
            <li
              style={{
                padding: "4px",
              }}
            >
              <ul className="flex flex-col gap-6 text-base">
                <li
                  className={`flex items-center gap-4 bg-gray cursor-pointer rounded-2xl text-[#FDFDFD] font-bold
            }`}
                  onClick={() => {
                    handleProfileTabClick("profile");
                  }}
                >
                  <img
                    src="/assets/images/proLogo.jpg"
                    alt="Profile"
                    style={{ height: "22px", width: "22px" }}
                  />
                  {t("Profile")}
                  <ArrowDropDownOutlined style={{ color: "#FDFDFD" }} />
                </li>
                {activeTab === "profile" && (
                  <>
                    <li
                      className={className}
                      style={{ marginLeft: "35px", padding: "4px" }}
                      onClick={handlePersonalInfo}
                    >
                      {t("Personal information")}
                    </li>
                    <li
                      className={className}
                      style={{ marginLeft: "35px", padding: "4px" }}
                      onClick={handleChangePassword}
                    >
                      {t("Change password")}
                    </li>
                  </>
                )}
              </ul>
            </li>
            <li
              style={{ padding: "4px" }}
              onClick={() => {
                handleClickOpen();
                handleTabClick("tab5");
              }}
              className={className}
            >
              <img
                className="h-6"
                src="/assets/images/LogoutIcon.png"
                alt="Logout"
              />
              {t("Logout")}
            </li>
          </ul>
        </div>
      </div>
      {open && isLogged && (
        <Logout
          open={open}
          isSmallScreen={isSmallScreen}
          handleLogout={handleLogout}
          handleClose={handleClose}
        />
      )}
    </ThemeProvider>
  );
}

export default BookingDetalisListSideNavigation;
